<template>
    <v-card>
        <v-card-title class="headline">Your password has been generated</v-card-title>
        <div v-if="newPsw.password">
            <v-card-text class="text-xs-center">
                <p>
                    Your new password is:<br/>
                    <strong>{{ newPsw.password }}</strong>
                </p>
            </v-card-text>
        </div>
        <div v-else>
            <v-card-text class="text-xs-center">
                Please wait
                <v-progress-linear
                        indeterminate
                        color="red"
                        class="mb-0"
                ></v-progress-linear>
            </v-card-text>
        </div>
        <v-card-actions v-if="newPsw.password">
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="closeMe">Close</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        props: {
            newPsw: Object
        },
        methods: {
            closeMe() {
                this.$emit('close-modal')
            }
        }
    }
</script>
